import app from '@/app';

/* @ngInject */
function Resource($resource) {
	return $resource(
		'api/projects/:id',
		{ id: '@id' },
		{
			create: { method: 'POST' },
			query: { method: 'GET' },
			all: { method: 'GET', params: { name: '' }, isArray: true },
			update: { method: 'PUT' },
			dependencies: { method: 'GET', url: 'api/projects/:id/dependencies' }
		}
	);
}

app.factory('ProjectEntity', Resource);
